module.exports = __webpack_public_path__ + "img/stpe1.4614e322.png";